import * as types from 'actions/types';
import * as infoPanelTypes from 'constants/infoPanelTypes';

const INITIAL_STATE = {
  extraInfoPanelActive: false,
  selectedOrder: null,
  selectedSubscription: null,
  listType: infoPanelTypes.ORDERS,
};

const centerPane = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_CENTER_PANE_EXTRA_INFO_PANEL_ACTIVE:
      return {
        selectedOrder: action.order,
        selectedSubscription: action.subscription,
        extraInfoPanelActive: action.value,
        listType: action.listType || infoPanelTypes.ORDERS,
      };
    default:
      return state;
  }
};

export default centerPane;
